/* Ramvico: «Protección de pedido» = como máximo UNA unidad por pedido.
   Es un producto normal de la tienda (1,99 €): Shopify fusiona las líneas idénticas sumando la cantidad, así que sin
   control cada «añadir con protección» sumaba otra unidad (3 packs = 3 × 1,99 €). Este ayudante lo comparten la landing
   y los configuradores de packs:
   - count / lines: unidades de protección que hay en un carrito (por variante o por handle del producto).
   - ensureSingle: si hay más de una, deja UNA y quita el resto (solo toca líneas de la protección, nunca otras).
   - sync / watch / refresh: la casilla refleja el carrito. Si ya hay protección queda marcada y desactivada («ya incluida»);
     si el cliente la quita del carrito, vuelve a estar activa y SIN marcar: no se vuelve a añadir sola.
   - En la página del carrito normaliza carritos que ya tuvieran más de una unidad.
   - Carrito lateral: bloque fijo arriba (casilla + precio) que añade/quita la protección y se sincroniza con el carrito. */
(function () {
  'use strict';
  if (window.RamvicoProtect) return;

  var HANDLE = 'proteccion-de-pedido';
  var INCLUDED_MSG = 'Ya incluida en tu carrito: solo se cobra una por pedido.';
  var cartBase = (window.routes && window.routes.cart_url) || '/cart';

  function isProtection(item, vid) {
    return (vid && String(item.variant_id) === String(vid)) || item.handle === HANDLE;
  }
  function lines(cart, vid) {
    return ((cart && cart.items) || []).filter(function (i) { return isProtection(i, vid); });
  }
  function count(cart, vid) {
    return lines(cart, vid).reduce(function (n, i) { return n + i.quantity; }, 0);
  }

  function read() {
    return fetch(cartBase + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store', credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
      .catch(function () { return null; });
  }

  // Deja como máximo una unidad: la primera línea de protección a 1 y las demás a 0, en UNA petición y solo con sus claves.
  // Devuelve el carrito resultante; rechaza si no se pudo comprobar que ha quedado una sola.
  function ensureSingle(cart, vid) {
    if (!cart || count(cart, vid) <= 1) return Promise.resolve(cart);
    var updates = {};
    lines(cart, vid).forEach(function (l, k) { updates[l.key] = k === 0 ? 1 : 0; });
    return fetch(cartBase + '/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) { if (!r.ok) throw new Error('update ' + r.status); return r.json(); })
      .then(function (after) {
        if (count(after, vid) > 1) throw new Error('siguen varias unidades');
        return after;
      });
  }

  // Refleja el carrito en la casilla de la sección (root): incluida (marcada y desactivada) o disponible (sin marcar).
  function sync(root, cart) {
    var input = root && root.querySelector('[data-protect]');
    if (!input || !cart) return;
    var status = root.querySelector('[data-protect-status]');
    var label = input.closest('label');
    var included = count(cart, input.value) >= 1;
    if (included) {
      input.checked = true;
      input.disabled = true;
      if (label) label.classList.add('is-included');
      if (status) { status.textContent = INCLUDED_MSG; status.hidden = false; }
    } else {
      if (input.disabled) { input.disabled = false; input.checked = false; } // se quitó del carrito: no se vuelve a marcar sola
      if (label) label.classList.remove('is-included');
      if (status) status.hidden = true;
    }
  }

  function refresh(root) {
    return read().then(function (c) { if (c) sync(root, c); return c; });
  }

  // La casilla sigue al carrito: al cargar, al volver a la pestaña o a la página, y cuando el tema avisa de un cambio.
  function watch(root) {
    if (!root || !root.querySelector('[data-protect]')) return;
    refresh(root);
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(root); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(root); });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      try { subscribe(PUB_SUB_EVENTS.cartUpdate, function () { refresh(root); }); } catch (e) { /* no crítico */ }
    }
  }

  // Página del carrito: un carrito que ya tuviera varias unidades se deja en una (y se recarga una vez).
  function guardCartPage() {
    if (location.pathname.replace(/\/+$/, '') !== String(cartBase).replace(/\/+$/, '')) return;
    read().then(function (c) {
      if (!c || count(c) <= 1) return;
      ensureSingle(c).then(function () { location.reload(); }, function () { /* sin cambios: se queda como está */ });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', guardCartPage);
  else guardCartPage();

  // ── Carrito lateral: bloque fijo arriba del todo (snippets/cart-drawer.liquid, [data-rv-cartprotect]) ──
  // La casilla refleja el carrito REAL: marcar añade UNA unidad, desmarcar quita las líneas de protección. El estado solo
  // cambia tras releer el carrito; si Shopify rechaza la operación o no se puede confirmar, se avisa y la casilla vuelve
  // al estado real (o al anterior si no se puede leer). Otras líneas del carrito no se tocan.
  var MSG_ADD_FAIL = 'No se ha podido añadir la protección de pedido. Tu carrito no ha cambiado.';
  var MSG_REMOVE_FAIL = 'No se ha podido quitar la protección de pedido. Sigue en tu carrito.';
  var MSG_UNKNOWN = 'No hemos podido confirmar el estado de la protección de pedido. Revisa tu carrito antes de continuar.';
  var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
  var updateUrl = (window.routes && window.routes.cart_update_url) || '/cart/update';
  var drawerBusy = false;

  function drawerBlock() { return document.querySelector('[data-rv-cartprotect]'); }
  function drawerMsg(text) {
    var b = drawerBlock(), m = b && b.querySelector('[data-rv-cartprotect-msg]');
    if (!m) return;
    m.textContent = text || '';
    m.hidden = !text;
  }
  function drawerPaint(cart) {
    var b = drawerBlock(), input = b && b.querySelector('[data-rv-cartprotect-input]');
    if (!input || !cart) return;
    input.checked = count(cart, b.getAttribute('data-variant-id')) >= 1;
  }
  function postJSON(url, body) {
    return fetch(url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); });
  }
  function fetchSection(id) {
    return fetch(cartBase + '?section_id=' + id + '&t=' + Date.now(), { cache: 'no-store', credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('section ' + r.status); return r.text(); })
      .then(function (t) { return new DOMParser().parseFromString(t, 'text/html'); });
  }
  // Repinta lista, pie, bloque e icono desde el servidor. Un carrito que queda vacío usa el estado vacío del propio cajón.
  function drawerRerender() {
    return Promise.all([fetchSection('cart-drawer'), fetchSection('cart-icon-bubble')]).then(function (docs) {
      var drawer = document.querySelector('cart-drawer'), src = docs[0].querySelector('cart-drawer');
      if (!drawer || !src) return;
      var empty = src.classList.contains('is-empty');
      drawer.classList.toggle('is-empty', empty);
      if (empty) {
        var inner = document.getElementById('CartDrawer'), srcInner = src.querySelector('#CartDrawer');
        if (inner && srcInner) inner.innerHTML = srcInner.innerHTML;
      } else {
        ['[data-rv-cartprotect]', 'cart-drawer-items', '.cart-drawer__footer'].forEach(function (sel) {
          var t = document.querySelector(sel), n = src.querySelector(sel);
          if (t && n) t.replaceWith(n);
        });
      }
      var bubble = document.getElementById('cart-icon-bubble'), sec = docs[1].querySelector('.shopify-section');
      if (bubble && sec) bubble.innerHTML = sec.innerHTML;
    });
  }

  function drawerToggle(input) {
    var b = input.closest('[data-rv-cartprotect]');
    if (!b || drawerBusy) { input.checked = !input.checked; return; }
    var vid = b.getAttribute('data-variant-id'), want = input.checked, before = !want;
    drawerBusy = true; input.disabled = true; b.setAttribute('aria-busy', 'true'); drawerMsg('');
    var unknown = false;
    read().then(function (cart) {
      if (!cart) { unknown = true; throw new Error('cart ilegible'); }
      var n = count(cart, vid);
      if (want) {
        if (n >= 1) return cart;                                   // ya hay una: no se añade otra
        return postJSON(addUrl, { items: [{ id: Number(vid), quantity: 1 }] }).then(read);
      }
      if (n === 0) return cart;
      var updates = {};
      lines(cart, vid).forEach(function (l) { updates[l.key] = 0; }); // solo las líneas de protección
      return postJSON(updateUrl, { updates: updates }).then(read);
    }).then(function (after) {
      if (!after) { unknown = true; throw new Error('sin confirmar'); }
      if (want && count(after, vid) > 1) return ensureSingle(after, vid);
      return after;
    }).then(function (after) {
      var n = count(after, vid);
      if (want ? n !== 1 : n !== 0) throw new Error('estado distinto del pedido');
      return drawerRerender().then(function () {
        var nb = drawerBlock();
        if (nb) { drawerPaint(after); var ni = nb.querySelector('[data-rv-cartprotect-input]'); if (ni) ni.focus(); }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ramvico-protect', cartData: after }); } catch (e) { /* no crítico */ }
        }
      });
    }).catch(function () {
      return read().then(function (real) {
        var cur = drawerBlock(), inp = cur && cur.querySelector('[data-rv-cartprotect-input]');
        if (real) drawerPaint(real); else if (inp) inp.checked = before; // sin lectura: se vuelve al estado anterior
        drawerMsg(unknown || !real ? MSG_UNKNOWN : (want ? MSG_ADD_FAIL : MSG_REMOVE_FAIL));
      });
    }).then(function () {
      drawerBusy = false;
      var cur = drawerBlock();
      if (cur) { cur.removeAttribute('aria-busy'); var i2 = cur.querySelector('[data-rv-cartprotect-input]'); if (i2) i2.disabled = false; }
    });
  }

  // Sincroniza el bloque con el carrito real (al abrir el cajón, al cambiar el carrito, al volver a la pestaña).
  function drawerSync() {
    if (drawerBusy || !drawerBlock()) return;
    read().then(function (c) {
      if (!c || drawerBusy) return;
      var b = drawerBlock(), vid = b && b.getAttribute('data-variant-id');
      if (b && count(c, vid) > 1) { // carrito antiguo con varias: se deja una
        return ensureSingle(c, vid).then(function (a) { return drawerRerender().then(function () { drawerPaint(a); }); }, function () { drawerMsg(MSG_UNKNOWN); });
      }
      drawerPaint(c);
    });
  }
  function drawerInit() {
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-rv-cartprotect-input]')) drawerToggle(e.target);
    });
    var dr = document.querySelector('cart-drawer');
    if (dr && window.MutationObserver) {
      new MutationObserver(function () { if (dr.classList.contains('active')) drawerSync(); }).observe(dr, { attributes: true, attributeFilter: ['class'] });
    }
    document.addEventListener('visibilitychange', function () { if (!document.hidden) drawerSync(); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) drawerSync(); });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      try { subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(drawerSync, 0); }); } catch (e) { /* no crítico */ }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', drawerInit);
  else drawerInit();

  window.RamvicoProtect = { count: count, lines: lines, read: read, ensureSingle: ensureSingle, sync: sync, refresh: refresh, watch: watch };
})();
